<template>
  <div class="book-turn__header">
    <div class="book-turn__header__logo">
      <div class="logo" v-if="pcLogo">
        <img width="140" height="40" :src="pcLogo" @click="goIndex" class="goIndex" alt="logo" />
      </div>
      <div class="book-turn__header__logo__search">
        <button class="search-button btn" v-if="displayOrNot.searchArticle" @click="goArticlePage">
          {{ languageOption.searchAll }}
        </button>
        <div class="search-wrap" v-if="displayOrNot.search">
          <el-input clearable v-model="searchKey" :palceholder="languageOption.pleaseEnterKeywords" class="search-input" @keyup.enter="searchWord(1)">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <button @click="searchWord(1)" class=" btn">{{ languageOption.search }}</button>
        </div>
        <div v-if="!(isEditDrawerShow && currentEditHeader === 'editContent')">
          <div v-if="displayOrNot.login && isLogin" class="book-header__login" @click="goPersonalPage">
            <img src="@imgs/paper/book-home.png" alt="" />
            <span>{{ languageOption.myHomepage }}</span>
          </div>
          <div v-if="displayOrNot.login && !isLogin" class="book-header__login" @click="goLogin">
            <img src="@imgs/paper/book-login.png" alt="" />
            <span>{{ languageOption.loginRegistration }}</span>
          </div>
          <img
            v-if="displayOrNot.collect"
            class="collect-button"
            @click="collect"
            :src="isCollect ? require('@imgs/toolbar/collect-button1.png') : require('@imgs/toolbar/collect-button.png')"
            alt="收藏"
          />
        </div>
      </div>
    </div>
    <ul class="book-turn__header__navigation" :style="{ 'background-color': colorSwitch === 1 ? colorContent['top-nav'] : '', color: colorSwitch === 1 ? colorContent['top-txt'] : '' }">
      <li style="position: relative">
        <span>{{ shareTitle }}</span>
        <span v-if="officialWeb && homePageTitle" @click="toPageUrl">{{ homePageTitle }}</span>
        <span v-if="displayOrNot.share" @click="openShareDialog">{{ languageOption.share }}</span>
        <span @click="showDownload" v-if="downloadValue == 2">{{ languageOption.download }}</span>
        <span class="shop" v-if="shop == 1" @click="changeShowShop(!showShop, true)">
          {{ pcBuyLinkName }}
          <div class="shop-wrapper" v-show="showShop" @click.stop="() => {}">
            <div v-for="(item, index) in linkList" :key="index" class="link-item" @click="goShop(item)">
              {{ item.name }}
            </div>
          </div>
        </span>
        <span @click="goQuestionaire" v-if="questionnaire">{{ pcQuestionName }}</span>
        <span class="item-font" @click="toListen" v-if="displayOrNot.tingWen === 1 && listenAbleArticleList.length > 0">
          {{ languageOption.listeningMode }}
        </span>
        <div style="display: inline;position: relative;cursor: pointer" v-if="audioLock" class="item-font" @click="changeAudio(!isAudioShow, true)">
          <span>{{ languageOption.sound }}</span>
          <play-audio-file
            class="play-audio-wrap"
            :class="!isShowCommerHeader && 't-17'"
            :show-turn="false"
            ref="playaudiofile"
            v-show="isAudioShow"
            @changeAudio="changeAudio"
            @isPlayAudio="isPlayAudio"
          />
        </div>

        <span v-if="historyResource && entryName" @click="toHistory">{{ entryName }}</span>
        <div class="previous-period-wrapper" :class="{ en: currentLang === 1 }">
          <span class="previous-period">{{ currentLang === 1 ? 'Calendar' : '往期' }}</span>
          <paper-date-picker
            :is-share="isShare"
            v-if="baozhiId"
            :paper-style="true"
            class="previous-period-wrap"
            :baozhiId="baozhiId"
            ref="PaperDatePicker"
            @updateVisible="updatePaperSwitchStatus"
            :allBooks="allBooks"
          />
        </div>
        <span style="margin-left: 20px" @click="more">{{ currentLang === 1 ? 'Other newspapers' : '查看其他报纸' }}</span>
      </li>
    </ul>
    <search-keys class="search-wrapper" v-show="isShowSK" :forbidden-transition="true" @closenow="closenow" ref="searchChild" @togo="togo" />

    <share-dialog v-if="!isStaticBook" ref="share" :qrObj="qrObj" :current-lang="currentLang" :qrVal="qrVal" :isInset="false" :title="currentLang === 1 ? 'Share publication' : '分享数字报'" />
    <down-load ref="showDownload" :has-article="listenAbleArticleList.length > 0" :isPaper="true" :format="formatListArr" :id="bookData.id"></down-load>
    <questionaire-form ref="questionaireForm" />
    <audio ref="audioFile" id="bgAudioFile" :src="currentMusic" :loop="currentMusicLoop" preload style="display: none;"></audio>
  </div>
</template>

<script>
import SearchKeys from '@components/searchKeys'
import shareDialog from '@components/books/components/ShareDialog'
import downLoad from '@components/books/components/download'
import questionaireForm from '@components/questionnaire'
import playAudioFile from '@components/books/components/playAudio'
import paperDatePicker from '@components/books/components/PaperDatePicker'
import { isPureNum } from '@utils'
import homeApi from '@api/home'
import login from '@api/login'
import apis from '@api/getBook'
import { mapState } from 'vuex'
import wx from 'weixin-js-sdk'
import getBookApi from '@api/getBook'

export default {
  name: 'PaperPageHeader',
  components: {
    SearchKeys,
    shareDialog,
    downLoad,
    questionaireForm,
    playAudioFile,
    paperDatePicker
  },

  computed: {
    ...mapState('book', ['isShowWindow', 'isShowCommerHeader']),
    ...mapState('common', ['appSize']),
    ...mapState('config', {
      questionContentLink: (state) => state.bookObj.questionContentLink,
      bookData: (state) => state.bookObj
    }),
    isStaticBook() {
      return this.$store.state.common.isStaticBook
    },
    shareTitle() {
      return this.$store.state.config.bookObj.shareTitle
    },
    userName() {
      return localStorage.getItem('username')
    },
    isLogin() {
      return this.$store.state.common.isLogin
    },
    displayOrNot() {
      return this.$store.state.config.bookObj.displayOrNot
    },
    audioData() {
      return this.$store.state.config.bookObj.audioData // 是否展示音乐图标
    },
    pcLogo: {
      get() {
        let newLogo = this.$store.state.config.pcLogo
        return newLogo ? newLogo : require('@imgs/footer/footer_logo.png')
      },
      set(newValue) {
        this.$store.commit('config/UPDATE_NEWLOGOTHUMBNAIL', newValue)
      }
    },
    currentEditHeader() {
      return this.$store.state.edit.currentEditHeader
    },
    isEditDrawerShow() {
      return this.$store.state.edit.isEditDrawerShow
    },
    baozhiId() {
      /*if (this.$store.state.config.bookObj.baozhiId) {
        this.loadHistoryBaokanList(this.$store.state.config.bookObj.baozhiId)
      }*/
      return this.$store.state.config.bookObj.baozhiId
    },
    showLink() {
      return this.$store.state.config.bookObj.buyLink
    },
    allDownloadVal() {
      return this.$store.state.config.allDownload
    },
    formatListArr() {
      return this.$store.state.config.bookObj.downloadFormat
    },
    pcBuyLinkName() {
      return this.$store.state.config.bookObj.pcBuyLinkName || '导购'
    },
    pcQuestionName() {
      return this.$store.state.config.bookObj.pcQuestionName || this.languageOption.questionnaire
    },
    questionnaire() {
      return this.$store.state.config.bookObj.questionnaire
    },
    shop() {
      return this.$store.state.config.bookObj.shop
    },
    downloadValue() {
      return this.$store.state.config.bookObj.downloadScope
    },
    isAudioShow() {
      return this.$store.state.book.isShowWindow === 5
    },
    logourl() {
      return this.$store.state.config.bookObj.logoUrl
    },
    officialWeb() {
      return this.$store.state.config.bookObj.officialWeb
    },
    homePageUrl() {
      return this.$store.state.config.bookObj.homePageUrl
    },
    homePageTitle() {
      return this.$store.state.config.bookObj.homePageTitle
    },
    historyResource() {
      return this.$store.state.config.bookObj.historyResource
    },
    entryName() {
      return this.$store.state.config.bookObj.entryName
    },
    entryUrl() {
      return this.$store.state.config.bookObj.entryUrl
    },
    articles() {
      //各版面文章目录
      if (this.bookData.catalog) {
        let catalog = JSON.parse(this.bookData.catalog)
        return (catalog ? catalog.catalogList : []) || []
      } else {
        return []
      }
    },
    colorSwitch() {
      return this.$store.state.config.bookObj.colorSwitch
    },
    colorContent() {
      return this.$store.state.config.bookObj.colorContent
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.currentLang]
    },
    currentLang() {
      return this.$store.state.config.bookObj.language
    }
  },
  data() {
    return {
      decryption_id: isPureNum(this.$route.query.id),
      searchKey: '',
      isShowSK: false,
      isCollect: false,
      collectId: '',
      workType: 'cloud_read_epaper',
      loginUrl: window.PROJECT_CONFIG.BASE_URL,
      qrObj: {
        value: window.location.href.replace('paperTurn', 'paperContentTurn').replace('paper?', 'paperContent?'),
        iframeUrl: '',
        isShowPoster: 0,
        title: '',
        qrVal: ''
      },
      qrVal: window.location.origin + '/elecPublish/paperContent?id=' + this.$route.query.id,
      isShowExtraBtns: true,
      audioLock: false, //是否显示播放音效按钮
      currentMusic: '',
      paperSwitchStatus: false, // 报纸类期刊时间选择器显示状态
      allBooks: null, // 往期期刊/报纸
      switchVisible: false,
      currentMusicLoop: false,
      linkList: [],
      showShop: false,
      isShare: this.$route.path.indexOf('Content') > -1,
      listenAbleArticleList: []
    }
  },
  created() {
    this.watchLogin()
    this.findOneCollect()
    this.handelData()
    const params = {
      id: this.decryption_id
    }
    // this.getBookDetails(params)
    this.getListenAbleArticleList()
  },
  mounted() {
    document.body.addEventListener('click', this.closeShowShop)
    if (this.audioData) {
      this.audioBgHandler(this.audioData)
    }
  },
  beforeMount() {
    document.body.removeEventListener('click', this.closeShowShop)
  },
  watch: {
    appSize(val) {
      this.isHiddenExtraBtns = false
      // this.isShowExtraBtns = true
      /*this.isHiddenPageBtns = false
      let width = val.width
      if ((this.buttonStyle === 0 && width <= 700) || (this.buttonStyle === 1 && width <= 900)) {
        this.isHiddenExtraBtns = true
        this.isHiddenPageBtns = true
      }
      if ((this.buttonStyle === 0 && width <= 900) || (this.buttonStyle === 1 && width <= 1425)) {
        this.isHiddenExtraBtns = true
        this.isShowExtraBtns = false
      }*/
    },
    isShowWindow(val) {
      // 快速切换互斥
      if (val !== 3) {
        this.$refs.refQuickSwitch && (this.$refs.refQuickSwitch.visible = false)
      }
      // 缩略图互斥
      if (val !== 4) {
        this.$refs.refThumb && (this.$refs.refThumb.visible = false)
      }
      // 声音控制互斥
    },
    showLink: {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          let Link = JSON.parse(newVal)
          let list = []
          if (Link.a.name !== undefined) {
            list.push(Link.a)
          }
          if (Link.b.name !== undefined) {
            list.push(Link.b)
          }
          if (Link.c.name !== undefined) {
            list.push(Link.c)
          }
          if (Link.d.name !== undefined) {
            list.push(Link.d)
          }
          if (Link.e.name !== undefined) {
            list.push(Link.e)
          }
          this.linkList = list
        } else {
          this.linkList = []
        }
      },
      deep: true,
      immediate: true
    },
    allDownloadVal() {
      // this.downloadValue = this.$store.state.config.bookObj.downloadScope
      // this.formatListArr = this.$store.state.config.bookObj.downloadFormat
    }
  },
  methods: {
    getListenAbleArticleList() {
      getBookApi.getArticleListByEpaperId({ epaperId: this.$route.query.id }).then((res) => {
        if (res && res.data && res.status === 200) {
          if (res.data.data.length) {
            res.data.data.forEach((edition) => {
              if (edition.xiaoYangList) {
                edition.xiaoYangList.forEach((xiaoyang) => {
                  this.listenAbleArticleList.push(xiaoyang)
                })
              }
            })
          }
        }
      })
    },
    toListen() {
      let routeUrl = this.$router.resolve({
        path: '/listen',
        query: { id: this.$route.query.id, type: this.$route.path.includes('paper') ? 'epaper' : 'ebook' }
      })

      window.open(routeUrl.href, '_blank')
    },
    audioBgHandler(val) {
      if (val.bgSound) {
        this.audioLock = true
        this.currentMusicLoop = val.loop ? true : false
        this.currentMusic = val.bgMusic
      } else {
        this.audioLock = false
      }
      if (val.turnSound === 1) {
        this.$store.commit('book/UPDATE_PLAY', true)
      } else {
        this.$store.commit('book/UPDATE_PLAY', false)
      }
      if (val.bgSound === 1) {
        // 不能自动播放
        $(document.body).one('click', () => {
          this.isPlayAudio(true)
        })
        // pc端自动播放
        this.isPlayAudio(true)
        // 移动端自动播放
        wx.ready(() => {
          this.isPlayAudio(true)
        })
      } else {
        this.isPlayAudio(false)
      }
    },
    goArticlePage() {
      this.$router.push({
        path: 'paperArticleShare',
        query: { user: this.$store.state.config.bookObj.creator }
      })
    },
    // 搜索书刊文字
    searchWord(page) {
      if (this.darkText && this.searchKey === '请输入关键字') {
        this.searchKey = ''
      }
      this.$refs.searchChild.search(page, this.searchKey)
      // this.showTip()
    },
    closenow(payload) {
      this.isShowSK = payload
    },
    togo(item) {
      if (item.edition && item.id && item.lineText && item.pageIndex && item.title && item.xuHao) {
        // readmodel=2读取文章
        this.$emit('togo', item)
        this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', true)
        // this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', true)
        this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
      }
    },
    openShareDialog() {
      // $('.menu-list').hide()
      // this.qrObj.value = window.location.href.replace('paperTurn', 'paperContentTurn')
      this.$refs.share.dialogVisible = true
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.title = this.shareTitle
    },
    async collect(type) {
      // await isLogin()
      let param = {
        worksId: this.$route.query.id,
        worksName: this.shareTitle,
        creator: this.userName,
        readModel: 2,
        worksType: this.workType
      }
      if (this.isCollect && type !== 'order') {
        homeApi.cancelCollect({ ids: this.collectId }).then((res) => {
          if (res.data.status === 0) {
            this.$message({
              message: this.languageOption.unsubscribed,
              type: 'success'
            })
            this.isCollect = false
            this.collectId = ''
          }
        })
      } else {
        homeApi.collectWork(param).then((res) => {
          if (res.data.status === 0) {
            this.$message({
              message: this.languageOption.addedToFavorites,
              type: 'success'
            })
            this.isCollect = true
            this.collectId = res.data.data.id
          } else {
            this.$message({
              message: res.data.message || '收藏失败',
              type: 'error'
            })
          }
        })
      }
    },
    goLogin() {
      window.location.href = this.loginUrl + '/fxsso/login?service=' + window.encodeURIComponent(window.location.href)
    },
    goPersonalPage() {
      this.$router.push({ path: '/personal' })
    },
    findOneCollect() {
      let param = {
        worksId: this.$route.query.id,
        worksType: this.workType
      }
      homeApi.findOneCollect(param).then((res) => {
        if (res.data.status === 0) {
          this.collectId = res.data.data.id
          this.isCollect = true
        }
      })
    },
    async watchLogin() {
      //检测登陆状态
      await login.login().then((res) => {
        if (res && res.data && res.status === 200) {
          let data = res.data
          if (data.code === 101) {
            this.$store.commit('common/UPDATE_IS_LOGIN', false)
          } else if (data.data.username) {
            this.$store.commit('common/UPDATE_IS_LOGIN', true)
          }
        }
      })
    },
    handelData() {
      var IS_TRUE = window.localStorage.getItem('IS_TRUE')
      if (IS_TRUE == 1) {
        this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'editContent')
        window.localStorage.setItem('IS_TRUE', 0)
      }
      // this.formatListArr = this.bookData.downloadFormat || ''
    },
    goIndex() {
      if (this.bookData.pcLogo != null && this.logourl) {
        window.open(this.logourl, '_blank')
      } else {
        window.open(`${window.PROJECT_CONFIG.BASE_URL}/elecPublish/`, '_blank')
      }
    },
    changeAudio(isShow, isDelay) {
      setTimeout(
        () => {
          // 如果未主动设置显隐，则当前取反
          if (isShow === undefined) {
            isShow = !this.isAudioShow
          }

          // 打开声音控制时，UPDATE_ISSHOWWINDOW改为5
          if (isShow) {
            this.$store.commit('book/UPDATE_ISSHOWWINDOW', 5)
          } else {
            this.$store.commit('book/UPDATE_ISSHOWWINDOW', 1)
          }
        },
        isDelay ? 50 : 0
      )
      // if (this.currentEditHeader === 'catalog') {
      //   this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
      //   // this.showChange = true
      // }
    },
    changeShowShop(isShow, isDelay) {
      setTimeout(
        () => {
          this.showShop = isShow
        },
        isDelay ? 50 : 0
      )
    },
    closeShowShop() {
      this.changeShowShop(false)
    },
    showDownload() {
      //出现下载弹窗
      this.$refs.showDownload.dialogVisible = true
    },
    goQuestionaire() {
      if (this.bookData.questionType === 0) {
        this.$refs.questionaireForm.visible = true
      } else if (this.bookData.questionType === 1) {
        if (this.questionContentLink !== '') {
          window.open(this.questionContentLink, '_blank')
        }
      }
    },

    isPlayAudio(payload) {
      if (payload) {
        this.$refs.audioFile && this.$refs.audioFile.play()
      } else {
        this.$refs.audioFile && this.$refs.audioFile.pause()
      }
    },

    processCatalogList(catalog, displayPageNo) {
      if (displayPageNo === 0 || !catalog) {
        return catalog
      }

      function deleteNode(arr) {
        let list = arr
        for (let i = 0; i < list.length; ) {
          if (list[i].page > displayPageNo) {
            list.splice(i, 1)
          } else if (list[i].children && list[i].children.length > 0) {
            deleteNode(list[i].children)
            i++
          } else {
            i++
          }
        }
      }

      deleteNode(catalog)
      return catalog
    },
    updatePaperSwitchStatus(status) {
      this.paperSwitchStatus = status
    },
    toPaperDate() {
      this.switchVisible = !this.switchVisible
    },
    more() {
      this.$router.push({ path: '/paperSharePage', query: { user: this.bookData.creator } })
    },
    goShop(item) {
      if (item.link !== '') {
        window.open(item.link, '_blank')
      }
    },
    toPageUrl() {
      if (!this.homePageUrl) return
      window.open(this.homePageUrl, '_blank')
    },
    toHistory() {
      if (!this.entryUrl) return
      window.open(this.entryUrl, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.book-turn__header {
  position: relative;
  .btn {
    width: 80px;
    height: 30px;
    text-align: center;
    border: none;
    background: #df5813;
    color: #fff;
    cursor: pointer;
  }

  //display: flex;
  //justify-content: end;
  margin-top: 20px;
  //padding: 0 20px;
  &__logo {
    display: flex;
    justify-content: space-between;
    padding: 0 20px 15px 20px;
    align-items: center;
    background-color: #fff;
    .logo {
      width: 40%;
      cursor: pointer;
    }
    .search-button {
      margin-right: 30px;
    }

    &__search {
      width: 60%;
      display: flex;
      gap: 10px;
      justify-content: flex-end;
      .search-wrap {
        //display: inline-block;
        //position: relative;
        display: flex;
        position: relative;

        /deep/.el-input__inner {
          height: 30px;
          border: 1px solid #eeeeee;
          border-radius: 0;
        }
        /deep/.el-input__prefix,
        .el-input__suffix {
          top: -6px;
        }
        /deep/.el-input__icon {
        }
        .search-content {
          position: absolute;
          top: 30px;
          z-index: 888;
        }
      }
      .collect-button {
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
      .book-header__login {
        display: inline-flex;
        align-items: center;
        padding: 5px 10px;
        height: 30px;
        cursor: pointer;
        position: relative;
        right: 10px;
        background: gray;
        color: #fff;
        vertical-align: 2px;
        margin: 0 0 0 10px;
        img {
          margin-right: 5px;
          transform: translateY(0) !important;
          width: 26px;
        }
      }
    }
  }
  &__navigation {
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
    height: 55px;
    line-height: 55px;
    color: #000000;
    background: #ffffff;
    li {
      span {
        cursor: pointer;
        margin-right: 25px;
      }
      span:last-child {
        margin-right: 0;
      }
      span:first-child {
        cursor: inherit;
      }
      span.item-font {
        position: relative;
      }
      span.previous-period {
        position: relative;
        margin-right: 0;
      }
      .previous-period-wrapper {
        display: inline-block;
        width: fit-content;
        height: 55px;
        position: relative;
        /*position: absolute;
        top: 0;
        left: auto;
        right: 110px;*/
        //border: 1px solid;
        z-index: 3;
        cursor: pointer;
      }
      .play-audio-wrap {
        position: absolute;
        top: 100%;
        z-index: 9999;
        /deep/ {
          .head {
            height: 22px;
          }
          .music-content {
            height: 30px;
          }
          .foot {
            height: 78px;
          }
        }
      }
      .t-17 {
        top: 17%;
      }

      span.shop {
        position: relative;
      }
      .shop-wrapper {
        position: absolute;
        z-index: 88878;
        width: 230px;
        border-radius: 10px;
        left: -208%;
        .link-item {
          background-color: #fff;
          width: 100%;
          height: 46px;
          line-height: 46px;
          text-align: center;
          //display: flex;
          //justify-content: center;
          //align-items: center;
          font-size: 14px;
          cursor: pointer;
          color: #000;
        }
        .link-item:hover {
          background-color: #ffede8;
        }
      }
    }
    .paper-date-wrapper {
      //width: 0;
      //height: 0;
    }
  }
  .search-wrapper {
    top: 36px;
    right: 15%;
    left: auto;
    height: calc(100vh - 100px);
    position: absolute;
  }
  .popperClass {
    right: 0;
  }
}
</style>
<style lang="scss">
.book-turn__header {
  &__navigation {
    li {
      .previous-period-wrapper {
        .paper-date-wrapper {
          .el-date-editor {
            .el-input__inner {
              width: 100%;
              padding: 0;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
